import React, { Component } from 'react';
import config from 'react-global-configuration';
import $ from 'jquery';
import { isApiResponse } from '../helpers/utils.js';
import TicketDetailTable from './TicketDetailTable.jsx';
import './TicketReport.css';

class ServicePerProductTab extends Component {
  constructor(props) {
    super(props);
    this._dt = null;
    this.state = {
      showDetails: false,
      selectedTeam: null,
      selectedColumnType: null
    };
  }

  componentDidMount() {
    if (this.props.shouldLoadData) {
      this.get_filtered_service_performance_product();
      this.props.onDataLoaded();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.shouldLoadData && !prevProps.shouldLoadData) {
      this.get_filtered_service_performance_product();
    } else if (
      prevProps.merchantID !== this.props.merchantID ||
      prevProps.chainID !== this.props.chainID ||
      prevProps.storeID !== this.props.storeID ||
      prevProps.yestSend !== this.props.yestSend ||
      prevProps.todSend !== this.props.todSend ||
      prevProps.issue_type !== this.props.issue_type ||
      prevProps.cf_issue_sub_category !== this.props.cf_issue_sub_category ||
      prevProps.city !== this.props.city ||
      prevProps.channel !== this.props.channel ||
      prevProps.product !== this.props.product ||
      prevProps.team !== this.props.team ||
      prevProps.rating !== this.props.rating
    ) {
      this.get_filtered_service_performance_product();
    }
  }

  componentWillUnmount() {
    if ($.fn.DataTable.isDataTable('#ProductTable')) {
      $('#ProductTable').DataTable().clear().destroy();
    }
  }

  get_filtered_service_performance_product() {
    var that = this;
    if (this.props.shouldLoadData) {
      const postData = {
        start_date: this.props.yestSend,
        end_date: this.props.todSend,
        merchant: this.props.merchantID || [],
        chain: this.props.chainID || [],
        store: this.props.storeID || [],
        issue_category: this.props.cf_issue_sub_category || [],
        city: this.props.city || [],
        channel: this.props.channel || [],
        product: this.props.product || [],
        team: this.props.team || [],
        rating: this.props.rating || [],
        group_by: 'product',
        report_code: 'service_performance_product_wise',
        download: 0
      };

      isApiResponse(false);

      if ($.fn.DataTable.isDataTable('#ProductTable')) {
        $('#ProductTable').DataTable().clear().destroy();
      }

      var ProductTable = $('#ProductTable').DataTable({
        order: [],
        processing: true,
        serverSide: true,
        bDestroy: true,
        paging: true,
        pageLength: 5,
        bInfo: false,
        autoWidth: true,
        responsive: false,
        searching: true,
        lengthMenu: [[5, 25, 50, 100, 500], [5, 25, 50, 100, 500]],
        ajax: {
          url: config.get('API_URL') + '/ServiceReport/service_performance',
          type: 'POST',
          data: postData,
          dataSrc: function (json) {
            isApiResponse(true);
            that.setState({ isChange: false });
            return json.data;
          },
          beforeSend: function (request) {
            request.setRequestHeader('Authorization', localStorage.usertoken);
          },
          error: function (data) {
            isApiResponse(true);
            alert('Failed to load data. Please try again');
            console.log('error', data);
          },
          complete: function (data) {
            isApiResponse(true);
          }
        },
        columns: [
          { data: 'Product', width: '180px' },
          { data: 'Opening Balance', width: '100px' },
          { data: 'Tickets Added', width: '100px' },
          { data: 'Within TAT - No Of Tickets Resolved', width: '100px' },
          { data: 'Within TAT - No Of Tickets Open', width: '100px' },
          { data: 'Outside TAT - No Of Tickets Resolved', width: '100px' },
          { data: 'Outside TAT - No Of Tickets Open', width: '100px' },
          { data: 'Closing Balance', width: '120px' },
          { data: '% Tickets QC Closed Within TAT', width: '120px' },
          { data: 'Reopened ticket by customer or repeated from same subscription', width: '180px' },
          { data: '% of Repeat Tickets', width: '100px' },
          { data: 'Average Rating', width: '100px' }
        ],
        columnDefs: [
          {
            targets: 0,
            render: function (data) {
              const val = data == null ? '' : String(data);
              return `<div class='text-wrap width-150'>${val}</div>`;
            }
          },
          {
            targets: [1, 2, 3, 4, 5, 6, 7, 9],
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData > 0) {
                $(td).css({ cursor: 'pointer' });
                $(td).on('click', function () {
                  that.handleCellClick(rowData, col);
                });
              }
            }
          },
          {
            targets: [8, 10],
            render: function (data) {
              return data == null ? '0%' : data + '%';
            }
          },
          {
            targets: [11],
            render: function (data) {
              return data == null ? '-' : data;
            },
            createdCell: function (td, cellData, rowData, row, col) {
              if (cellData != null) {
                $(td).css({ cursor: 'pointer' });
                $(td).on('click', function () {
                  that.handleCellClick(rowData, col);
                });
              }
            }
          }
        ]
      });

      if (that.props.object_type === 'Innoviti') {
        ProductTable.columns([8, 11]).visible(true);
      } else {
        ProductTable.columns([8, 11]).visible(false);
      }
    }
  }

  handleCellClick(rowData, colIndex) {
    const productName = rowData['Product'];
    const columnMapping = {
      1: 'opening_balance',
      2: 'tickets_added',
      3: 'within_tat_resolved',
      4: 'within_tat_open',
      5: 'outside_tat_resolved',
      6: 'outside_tat_open',
      7: 'closing_balance',
      9: 'repeat_tickets',
      11: 'has_rating'
    };
    const columnType = columnMapping[colIndex];
    if (columnType) {
      this.setState({
        showDetails: true,
        selectedTeam: productName,
        selectedColumnType: columnType
      });
    }
  }

  closeDetails() {
    this.setState({
      showDetails: false,
      selectedTeam: null,
      selectedColumnType: null
    });
  }

  render() {
    const { showDetails, selectedTeam, selectedColumnType } = this.state;
    return (
      <div className="merchant-tab-content service-report">
        <div className="content-tdetails-table table-full-width table-responsive marginTop0">
          <table id="ProductTable" className="table table-striped table-hover">
            <thead>
              <tr>
                <th rowSpan="2" className="merchant-header-default">Product</th>
                <th rowSpan="2" className="merchant-header-default">Opening Balance</th>
                <th rowSpan="2" className="merchant-header-default">Tickets Added</th>
                <th colSpan="2" className="merchant-header-default">Within TAT</th>
                <th colSpan="2" className="merchant-header-default">Outside TAT</th>
                <th rowSpan="2" className="merchant-header-default">Closing Balance</th>
                <th rowSpan="2" className="merchant-header-default">% Tickets QC Closed Within TAT</th>
                <th rowSpan="2" className="merchant-header-default">Count of tickets re-opened by customer or repeated from same subscription</th>
                <th rowSpan="2" className="merchant-header-default">% of Repeat Tickets</th>
                <th rowSpan="2" className="merchant-header-default">Average Rating</th>
              </tr>
              <tr>
                <th className="merchant-header-default">No. Of Tickets Resolved</th>
                <th className="merchant-header-default">No. Of Tickets Open</th>
                <th className="merchant-header-default">No. Of Tickets Resolved</th>
                <th className="merchant-header-default">No. Of Tickets Open</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>

        {showDetails && (
          <TicketDetailTable
            key={`${selectedTeam}-${selectedColumnType}`}
            tableId="servicePerProductDetailsTable"
            apiUrl="/ServiceReport/service_performance_details"
            postData={{
              start_date: this.props.yestSend,
              end_date: this.props.todSend,
              download: 0,
              group_by: 'product',
              group_value: selectedTeam,
              column_type: selectedColumnType,
              merchant: this.props.merchantID || [],
              chain: this.props.chainID || [],
              store: this.props.storeID || [],
              issue_category: this.props.cf_issue_sub_category || [],
              city: this.props.city || [],
              channel: this.props.channel || [],
              product: this.props.product || [],
              team: this.props.team || [],
              rating: this.props.rating || []
            }}
            title={`Ticket Details - ${selectedTeam}`}
            columnType={selectedColumnType}
            objectType={this.props.object_type}
            onClose={() => this.closeDetails()}
            downloadConfig={{
              fn: 'service_performance_product_wise_details.csv.gz',
              url: '/service_reports/service_performance_details',
              filters: {
                start_date: this.props.yestSend,
                end_date: this.props.todSend,
                download: 1,
                report_code: 'service_performance_product_wise_details',
                group_by: 'product',
                group_value: selectedTeam,
                column_type: selectedColumnType,
                merchant: this.props.merchantID,
                chain: this.props.chainID || [],
                store: this.props.storeID,
                issue_category: this.props.cf_issue_sub_category,
                city: this.props.city,
                channel: this.props.channel,
                product: this.props.product,
                team: this.props.team,
                rating: this.props.rating
              },
              timeout: 180
            }}
          />
        )}
      </div>
    );
  }
}

export default ServicePerProductTab;
